import { useQuery } from '@tanstack/react-query';
import { Mic, Upload, Play, ArrowRightCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getVoiceMemos } from '@/lib/api';

function openVoiceMemoManager(openInNewTab = false) {
  window.dispatchEvent(new CustomEvent('integration-view-change', {
    detail: {
      tabId: 'integration-voice-memos',
      title: 'Voice Memos',
      type: 'integration-voice-memos',
      integrationData: {
        integrationId: 'voice-memos'
      },
      openInNewTab
    }
  }));
}

export function VoiceMemoSidebar() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['voice-memos-stats'],
    queryFn: async () => {
      const [all, unprocessed] = await Promise.all([
        getVoiceMemos(),
        getVoiceMemos({ status: 'unprocessed' })
      ]);
      return {
        total: all.memos.length,
        unprocessed: unprocessed.memos.length
      };
    }
  });

  return (
    <div className="h-full flex flex-col p-4">
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          {/* <Mic className="w-5 h-5" />
          <h3 className="font-semibold">Voice Memos</h3> */}
        </div>
        {isLoading ? (
          <div className="text-sm text-muted-foreground">Loading...</div>
        ) : stats ? (
          <div className="text-sm text-muted-foreground">
            {stats.unprocessed} unprocessed of {stats.total} total
          </div>
        ) : null}
      </div>

      <div className="flex flex-col gap-2 mb-4">
        <Button
          variant="default"
          size="sm"
          className="w-full"
          onClick={(event) => openVoiceMemoManager(event.metaKey || event.ctrlKey)}
        >
          <ArrowRightCircle className="w-4 h-4 mr-2" />
          Voice Memo Manager
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={(event) => {
            event.preventDefault();
            openVoiceMemoManager(event.metaKey || event.ctrlKey);
          }}
        >
          <Upload className="w-4 h-4 mr-2" />
          Upload Files
        </Button>
        {stats && stats.unprocessed > 0 && (
          <Button
            variant="secondary"
            size="sm"
            className="w-full"
            onClick={(event) => openVoiceMemoManager(event.metaKey || event.ctrlKey)}
          >
            <Play className="w-4 h-4 mr-2" />
            Process All ({stats.unprocessed})
          </Button>
        )}
      </div>

      <div className="flex-1 overflow-auto">
        {/* Recent memos list could go here */}
        <Button
          variant="ghost"
          className="w-full justify-center text-muted-foreground"
          onClick={(event) => openVoiceMemoManager(event.metaKey || event.ctrlKey)}
        >
          View full manager
        </Button>
      </div>
    </div>
  );
}

